'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var debug = {exports: {}};

exports.debug = debug;
